import { useQuery } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '~/primitives/dialog';
import { LevelRecordEntry } from '~/components/LevelRecordEntry';
import { ModalProps } from '~/util';
import { useList } from '~/util/hooks/useList';
import { clanLevelRecordsQuery } from '~/util/queries/public/profiles';
import { BaseLevel } from '~/util/types/levels';
import { ScrollArea } from '~/primitives/scroll-area';

type ClanLevelRecordsDialogProps = {
    level: BaseLevel;
} & ModalProps;

const Route = getRouteApi('/profile/clan/$clanid');

export const ClanLevelRecordsDialog = ({
    level,
    ...modalProps
}: ClanLevelRecordsDialogProps) => {
    const list = useList();

    const clan = Route.useLoaderData({
        select: ({ profile: { clan } }) => clan,
    });

    const records =
        useQuery(
            clanLevelRecordsQuery({ list, clanid: clan.id, levelid: level.id }),
        )?.data ?? [];

    return (
        <Dialog {...modalProps}>
            <DialogContent disableDialogScroll className="w-2xl">
                <DialogHeader>
                    <DialogTitle>Clan Records for {level.name}</DialogTitle>
                    <DialogDescription>
                        {records.length} member{records.length !== 1 ? 's' : ''}{' '}
                        of {clan.global_name}{' '}
                        {records.length !== 1 ? 'have' : 'has'} completed this
                        level.
                    </DialogDescription>
                </DialogHeader>
                <ScrollArea className="min-h-0 flex-1 mt-3">
                    {records.map((record) => (
                        <LevelRecordEntry
                            key={record.id}
                            record={record}
                            showDetailsOnTheSide
                        />
                    ))}
                </ScrollArea>
            </DialogContent>
        </Dialog>
    );
};
